var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandshakeBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 5.0625H14.4083C13.9575 5.0625 13.732 5.0625 13.5195 4.99813C13.3069 4.93378 13.1194 4.80874 12.7442 4.55865C12.1816 4.18352 11.5396 3.75559 11.2207 3.65904C10.9019 3.5625 10.5637 3.5625 9.88747 3.5625C8.96782 3.5625 8.37502 3.5625 7.96155 3.73377C7.54807 3.90504 7.22292 4.2302 6.5726 4.88052L6.00029 5.45283C5.85373 5.59939 5.78045 5.67267 5.73521 5.74501C5.56751 6.01321 5.5861 6.35779 5.78167 6.60638C5.83443 6.67345 5.91517 6.73842 6.07663 6.86837C6.67347 7.34868 7.5339 7.30074 8.07435 6.75706L9 5.82589H9.75L14.25 10.3527C14.6642 10.7694 14.6642 11.4449 14.25 11.8616C13.8358 12.2783 13.1642 12.2783 12.75 11.8616L12.375 11.4844M12.375 11.4844L10.125 9.221M12.375 11.4844C12.7892 11.9011 12.7892 12.5767 12.375 12.9933C11.9608 13.41 11.2892 13.41 10.875 12.9933L10.125 12.2389M10.125 12.2389C10.5392 12.6555 10.5392 13.3311 10.125 13.7478C9.71077 14.1644 9.03922 14.1644 8.625 13.7478L7.5 12.616M10.125 12.2389L8.625 10.7389M7.5 12.616L7.125 12.2389M7.5 12.616C7.91422 13.0327 7.91422 13.7083 7.5 14.125C7.08579 14.5417 6.41422 14.5417 6 14.125L3.88228 11.9632C3.44711 11.5189 3.22953 11.2969 2.95076 11.1796C2.67199 11.0625 2.36106 11.0625 1.7392 11.0625H1.5",
    stroke: "black",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 11.0625H14.625",
    stroke: "black",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 5.0625H1.5",
    stroke: "black",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandshakeBlack);
export default __webpack_public_path__ + "static/media/handshake-black.fe65c49c14f8e8c62a851825d6f6949b.svg";
export { ForwardRef as ReactComponent };